import React from 'react';
import { useAppContext, ACTIONS } from '../context/AppContext';
import PatientInfoPanel from './PatientInfoPanel';
import { getCallStyling } from '../utils/styleUtils';

const ConversationView = () => {
  const { state, dispatch } = useAppContext();
  const { currentInteraction, interactionTypes } = state;

  const handleMarkComplete = () => {
    if (!currentInteraction) return;
    dispatch({ type: ACTIONS.UPDATE_INTERACTION_STATUS, payload: { interactionId: currentInteraction.id, status: 'Approved' } });
    dispatch({ type: ACTIONS.CHANGE_WIDGET_VIEW, payload: 'callQueue' });
    dispatch({ type: ACTIONS.SET_PMS_VIEW, payload: 'scheduler' });
    dispatch({ type: ACTIONS.SET_BOOKING_STEP, payload: 'idle' });
  };

  const handleMarkTrash = () => {
    if (!currentInteraction) return;
    dispatch({ type: ACTIONS.UPDATE_INTERACTION_STATUS, payload: { interactionId: currentInteraction.id, status: 'Rejected' } });
    dispatch({ type: ACTIONS.CHANGE_WIDGET_VIEW, payload: 'callQueue' });
  };

  const toggleTranscript = () => {
    dispatch({ type: ACTIONS.TOGGLE_TRANSCRIPT });
  };

  if (!currentInteraction) {
    return (
      <div className="p-4 text-center text-gray-500">
        Select a call from the queue.
      </div>
    );
  }
  
  const { label, pill, dot } = getCallStyling(currentInteraction, interactionTypes);

  return (
    <div className="h-full flex flex-col bg-gray-50">
      {/* Header */}
      <div className="flex items-center justify-between p-2 border-b border-gray-200">
        <button
          onClick={() => dispatch({ type: ACTIONS.CHANGE_WIDGET_VIEW, payload: 'callQueue' })}
          className="flex items-center text-sm text-gray-600 hover:text-gray-900"
        >
          <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" /></svg>
          Back to Queue
        </button>
        <div className="flex items-center space-x-2">
          <span className={`text-xs px-2 py-1 rounded-full border ${pill}`}>
            {label}
          </span>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 overflow-y-auto p-4 pt-2 space-y-4">
        <div className="bg-white p-4 rounded-lg border border-gray-200">
            <h3 className="text-lg font-semibold text-gray-800 mb-2">Request</h3>
            <p className="text-gray-600 text-sm">
                {currentInteraction.request}
            </p>
        </div>
        <PatientInfoPanel />

        <div className="text-center">
            <button
                onClick={toggleTranscript}
                className="text-blue-600 hover:underline text-sm font-medium"
            >
                View Transcript
            </button>
        </div>
      </div>
      
       {/* Footer */}
       <div className="flex-shrink-0 p-4 border-t border-gray-200 bg-white space-y-2">
            <button
                onClick={handleMarkComplete}
                className="w-full bg-green-500 text-white py-2 px-4 rounded-lg hover:bg-green-600 transition-colors"
            >
                Mark Complete
            </button>
            <button
                onClick={handleMarkTrash}
                className="w-full flex items-center justify-center space-x-2 py-2 px-4 rounded-lg border border-gray-300 bg-transparent text-gray-500 hover:text-red-500 hover:border-red-500 transition-colors group"
            >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400 group-hover:text-red-500 transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
                <span>Mark Trash</span>
            </button>
       </div>
    </div>
  );
};

export default ConversationView; 